/**
 * Undo and redo (SRS C6).
 *
 * docs/06-UI-SPEC.md §6.2 puts these at the bottom of the left tool rail, which is
 * built in Phase 4. Until then they sit at the top of the properties panel, beside
 * the other controls that are waiting for the same rail.
 *
 * Each button undoes only this person's own work. A teacher pressing undo can never
 * take a line off a student's board, which is why nothing here asks whose turn it is.
 */

import { RedoIcon, UndoIcon } from '../../assets/icons.js';

export interface UndoRedoProps {
  readonly onUndo: () => void;
  readonly onRedo: () => void;
}

const BUTTON =
  'flex h-touch flex-1 items-center justify-center gap-2 rounded-md border border-border bg-surface text-sm text-text-primary transition-colors duration-fast hover:bg-surface-hover';

export function UndoRedo({ onUndo, onRedo }: UndoRedoProps) {
  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Your work</h3>
      <div className="flex gap-2">
        <button type="button" onClick={onUndo} className={BUTTON} title="Undo (Ctrl+Z)">
          <UndoIcon size={18} />
          Undo
        </button>
        <button type="button" onClick={onRedo} className={BUTTON} title="Redo (Ctrl+Shift+Z)">
          <RedoIcon size={18} />
          Redo
        </button>
      </div>
    </section>
  );
}
